import interact from "@interactjs/interact";
import interactablePreventDefault from "@interactjs/core/interactablePreventDefault";
import actions from "@interactjs/actions/plugin";
import autoStart from "@interactjs/auto-start/plugin";
import inertia from "@interactjs/inertia/plugin";
import modifiers from "@interactjs/modifiers/plugin";
import pointerEvents from "@interactjs/pointer-events/plugin";

/**
 * The `@interactjs/interactjs` umbrella package is marked `sideEffects: false`,
 * so bundlers tree-shake away its plugin registrations and `interact(el)` ships
 * without `.draggable()`/`.resizable()`. Register the plugins here, in app code,
 * so the calls always run. `actions` adds draggable/resizable; `autoStart`
 * actually begins the gesture on pointer move.
 */
interact.use(interactablePreventDefault);
interact.use(pointerEvents);
interact.use(inertia);
interact.use(modifiers);
interact.use(autoStart);
interact.use(actions);

export default interact;
